import { useQuery } from "@tanstack/react-query";
import { getMonthlySummaryHours } from "../api/timeEntryApi";
import { timeEntryKeys } from "../api/timeEntryKeys";

// Provee el listado de imputaciones mensuales del colaborador para la tabla.
export const useMonthlySummary = () =>
  useQuery({
    queryKey: timeEntryKeys.monthlySummary(),
    queryFn: getMonthlySummaryHours,
  });
